export const theme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 415,
      md: 768,
      lg: 992,
      xl: 1200
    }
  },
  typography: {
    useNextVariants: true
  },
  palette: {
    primary1Color: '#F47E1F',
    primary2Color: '#F26155',
    accent1Color: '#f50057',
    accent2Color: '#d81b60',
    accent3Color: '#e91e63'
  },
  bottomNavigation: {
    selectedColor: '#c2185b'
  }
};
